import PropTypes from 'prop-types'
import { MdRocketLaunch } from 'react-icons/md'
import LoadingSpinner from './LoadingSpinner'

function LoadingPage({
  title = 'Loading DialVerse',
  subtitle = 'Please wait while we prepare your experience',
  showLogo = true,
  className = '',
}) {
  return (
    <div
      className={`min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark px-4 py-12 sm:px-6 lg:px-8 ${className}`}
    >
      <div className="w-full max-w-md space-y-8 text-center">
        {/* Logo/Brand Section */}
        {showLogo && (
          <div className="flex flex-col items-center space-y-4">
            <div className="w-20 h-20 bg-primary-100 dark:bg-primary-900/50 rounded-full flex items-center justify-center">
              <MdRocketLaunch className="text-4xl text-primary-600 dark:text-primary-400" />
            </div>
            <div className="space-y-2">
              <h1 className="text-2xl font-bold text-neutral-900 dark:text-white">DialVerse</h1>
              <p className="text-sm text-neutral-500 dark:text-neutral-400">
                Aviation Simulation Platform
              </p>
            </div>
          </div>
        )}

        {/* Loading Content */}
        <div className="space-y-6">
          <div className="flex flex-col items-center space-y-4">
            <LoadingSpinner size="xl" />
            <div className="space-y-2">
              <h2 className="text-xl font-semibold text-neutral-900 dark:text-white">{title}</h2>
              <p className="text-sm text-neutral-600 dark:text-neutral-400 max-w-sm">{subtitle}</p>
            </div>
          </div>

          {/* Loading Dots Animation */}
          <div className="flex justify-center space-x-1">
            <div
              className="w-2 h-2 bg-primary-600 dark:bg-primary-400 rounded-full animate-bounce"
              style={{ animationDelay: '0ms' }}
            ></div>
            <div
              className="w-2 h-2 bg-primary-600 dark:bg-primary-400 rounded-full animate-bounce"
              style={{ animationDelay: '150ms' }}
            ></div>
            <div
              className="w-2 h-2 bg-primary-600 dark:bg-primary-400 rounded-full animate-bounce"
              style={{ animationDelay: '300ms' }}
            ></div>
          </div>
        </div>

        {/* Footer */}
        <div className="pt-8">
          <p className="text-xs text-neutral-400 dark:text-neutral-500">
            Powered by advanced aviation simulation technology
          </p>
        </div>
      </div>
    </div>
  )
}

LoadingPage.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  showLogo: PropTypes.bool,
  className: PropTypes.string,
}

export default LoadingPage
